import { cn } from 'utils/cn';
import type { AnnouncementBanner } from 'types/announcements';

const STYLES_CLASSES: Record<string, string> = {
  neutral: 'bg-[#edece7] text-[#1f2427]',
  accent: 'bg-[#0f2b3c] text-white',
  info: 'bg-[#e6edf1] text-[#0f2b3c]',
  warning: 'bg-[#f6e3bd] text-[#3a2a08]',
};

export const BannerPreview = ({
  banner,
  compact,
}: {
  banner: AnnouncementBanner;
  compact?: boolean;
}) => {
  const styleClass = STYLES_CLASSES[banner.style] ?? STYLES_CLASSES.neutral;
  const customStyle =
    banner.style === 'custom' && banner.color
      ? { backgroundColor: banner.color, color: '#ffffff' }
      : undefined;

  return (
    <div
      className={cn(
        'rounded-sm px-4 py-3',
        compact ? 'text-sm' : 'text-[15px]',
        banner.style === 'custom' ? '' : styleClass,
      )}
      style={customStyle}
    >
      <p className="whitespace-pre-line leading-relaxed">{banner.text}</p>
      {banner.link ? (
        <a href={banner.link.url} className="mt-1 inline-block underline underline-offset-2">
          {banner.link.label}
        </a>
      ) : null}
    </div>
  );
};
